export enum GridButtonMode {
    View = "View",
    Edit = "Edit",
    Add  = "Add"
}
